import { colors } from '@procore/core-react';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '28px',
    marginBottom: '12px',
    [theme.breakpoints.down(960)]: {
      fontSize: '18px',
      fontWeight: 700,
      lineHeight: '24px',
      marginBottom: '12px',
    },
  },
  sectionText: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    whiteSpace: 'pre-line',
    marginBottom: '24px',
    letterSpacing: '0px',
    [theme.breakpoints.down(960)]: {
      lineHeight: '20px',
    },
  },
  descriptiveInfo: {
    margin: '0 10px 0 5px',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 400,
    textWrap: 'wrap',
    letterSpacing: '0px',
    [theme.breakpoints.down(960)]: {
      margin: '0 10px 0 12px',
    },
  },
  descriptiveInfoContainer: {
    alignItems: 'baseline',
    marginBottom: '12px',
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      alignItems: 'flex-start',
      marginTop: '24px',
      marginBottom: '24px',
      flexDirection: 'column',
    },
  },
  descriptionWithIcon: {
    margin: '0 0 0 0',
    fontSize: '16px',
    fontWeight: 400,
    textWrap: 'wrap',
    marginTop: '0px',
    marginBottom: '8px',
    [theme.breakpoints.down(960)]: {
      marginTop: '0px',
      marginBottom: '8px',
    },
  },
  showMoreOrLessText: {
    color: colors.black,
    display: 'block',
    fontSize: '16px',
    textDecoration: 'underline',
    '&:hover': { cursor: 'pointer' },
  },
}));
